import { MONTHS } from 'app-constants';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Box, Text } from '../../../../shared/Typhography';

import { RevenueTable } from './Components';

const Container = styled.div`
  margin-top: 150px;
`;

export default function InsightDetailsScreen() {
  const { date } = useParams<{ date: string }>();
  const [dateString, setDateString] = React.useState<string>();

  React.useEffect(() => {
    const dateInstance = new Date(+date.slice(0, 4), +date.slice(4, 6) - 1, +date.slice(6));

    setDateString(
      `${dateInstance.getDate()} ${MONTHS[dateInstance.getMonth()]} ${dateInstance.getFullYear()}`,
    );
  }, [date]);

  return (
    <Container>
      <Box style={{ marginBottom: '20px' }}>
        <Text size={2}>{dateString}</Text>
      </Box>
      {/* <Box> <RevenueGraphs /> </Box> */}
      <Box>
        <RevenueTable />
      </Box>
    </Container>
  );
}
